var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorkCardImg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 58,
    viewBox: "0 0 70 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.3262 18.6617H34.5264H22.8268C21.5641 18.6617 20.5405 17.6381 20.5405 16.3754V2.53728C20.5405 1.27459 21.5641 0.250977 22.8268 0.250977H47.3262C48.5889 0.250977 49.6125 1.27459 49.6125 2.53727V16.3754C49.6125 17.6381 48.5889 18.6617 47.3262 18.6617Z",
    fill: "url(#paint0_linear_1599_7689)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.42009 38.9978H14.6735H26.8179C28.0805 38.9978 29.1042 40.0214 29.1042 41.2841V55.1222C29.1042 56.3849 28.0805 57.4085 26.8179 57.4085H2.42009C1.1574 57.4085 0.133789 56.3849 0.133789 55.1222V41.2841C0.133789 40.0214 1.1574 38.9978 2.42009 38.9978Z",
    fill: "url(#paint1_linear_1599_7689)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1819 38.9978H55.7116H67.5797C68.8424 38.9978 69.866 40.0214 69.866 41.2841V55.1222C69.866 56.3849 68.8424 57.4085 67.5797 57.4085H43.1819C41.9192 57.4085 40.8956 56.3849 40.8956 55.1222V41.2841C40.8956 40.0214 41.9192 38.9978 43.1819 38.9978Z",
    fill: "url(#paint2_linear_1599_7689)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1599_7689",
    x1: -59.1056,
    y1: -119.963,
    x2: 0.791306,
    y2: 202.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1AEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1599_7689",
    x1: -59.1056,
    y1: -119.963,
    x2: 0.791306,
    y2: 202.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1AEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1599_7689",
    x1: -59.1056,
    y1: -119.963,
    x2: 0.791306,
    y2: 202.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1AEFE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkCardImg3);
export default __webpack_public_path__ + "static/media/workCardImg3.ca120cd1ec606801174cedce90c0135c.svg";
export { ForwardRef as ReactComponent };